import { Component } from '@angular/core';

@Component({
    selector: 'iris-card-body',
    templateUrl: './iris-card-body.component.html',
    styleUrls: ['./iris-card-body.component.scss'],
    standalone: false
})
export class IrisCardBodyComponent {}
